import type { ICard } from "../../cardsSlice";

export const major13Card: ICard = {
    id: "major_13",
    arcana: "major",
    number: 13,
    suit: "major",
    court: "major",
    name: "Смерть",
    nameEn: "Death",
    keywords: ["Конец", "Трансформация", "Обновление"],
    symbolism: [
      "Скелет на коне",
      "Падающие фигуры",
      "Чёрный флаг с белой розой",
      "Восходящее солнце на горизонте"
    ],
    symbolismInterpretation:
      "Окончание одного этапа и начало другого; символ внутренней трансформации",
    archetype: "Неизбежность перемен, архетип разрушения старого ради нового",
    psychology: "Прекращение привязанностей, отпускание, внутреннее обновление",
    upright: {
      personality: "Готовность к переменам, внутренняя зрелость",
      relationships: "Завершение цикла, переосмысление связей",
      work: "Окончание этапа, переход в новую фазу",
      spirituality: "Преображение, смерть старой личности",
      examples: ["Освобождение от прошлого", "Смена этапа", "Трансформация"]
    },
    reversed: {
      meaning: "Страх перемен, застревание, отказ отпустить",
      nuances: "Сопротивление необходимому завершению"
    },
    associations: ["Конец", "Переход", "Очищение", "Обновление"],
    combinations: ["С Башней — резкие, разрушительные перемены", "Со Звездой — надежда после окончания"],
    readingTips: ["Не бояться перемен", "Видеть в завершении начало нового"],
    selfQuestions: ["Что мне нужно завершить?", "Что во мне рождается заново?"]
  };


